import { ExternalLinkIcon } from 'lucide-react';
import { shopHref } from '../../utils/hosts';
import { btnSecondary } from '../ui/styles';

/** "Bekijk op de site" naast een editor: opent de pagina in de webshop in een nieuw tabblad. */
export function ViewOnSite({
  path
}: {
  path: string;
}) {
  return <a href={shopHref(path)} target="_blank" rel="noreferrer" className={btnSecondary} data-id="element-989" data-mp="2uqxoo4hlz7h5">
      Bekijk op de site
      <ExternalLinkIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-990" data-mp="2pse15znd9nmo" />
      <span className="sr-only" data-id="element-991" data-mp="2kt1fvjc58om7"> (opent in een nieuw tabblad)</span>
    </a>;
}